import { render, staticRenderFns } from "./DashboardTiles.vue?vue&type=template&id=123c2d41&"
import script from "./DashboardTiles.vue?vue&type=script&lang=js&"
export * from "./DashboardTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports